import { render, staticRenderFns } from "./IncomeAccountAlert.vue?vue&type=template&id=e2f42aa4&"
import script from "./IncomeAccountAlert.vue?vue&type=script&lang=js&"
export * from "./IncomeAccountAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports